import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { BLOCK_TYPES } from './blockCatalog';
import ListSignupSettings from './ListSignupSettings';
import SpecialOccasionSettings from './SpecialOccasionSettings';
import WaitSettings from './WaitSettings';
import IssueVoucherSettings from './IssueVoucherSettings';
import IncreaseVoucherSettings from './IncreaseVoucherSettings';
import GetResponseSyncSettings from './GetResponseSyncSettings';
import GetResponseTagSettings from './GetResponseTagSettings';
import ConditionSettings from './ConditionSettings';
import ConditionalSplitSettings from './ConditionalSplitSettings';
import TriggerSettings from './TriggerSettings';
import ActionBlockSettings from './ActionBlockSettings';

const TRIGGER_SETTINGS_TYPES = [
  'bookingCompleted',
  'visitCompleted',
  'bookingNoShow',
  'abandonedBooking',
  'inactivity',
  'consentGranted',
  'tagAdded',
  'occasionDue',
  'manualSegment',
  'apiTrigger',
];

const ACTION_SETTINGS_TYPES = ['abSplit', 'addToList', 'removeFromList', 'addTag', 'removeTag', 'notifyTeam'];

// "Eigenschaften" sidebar tab: renders the settings form of the selected block.
const BlockPropertiesPanel = ({
  block,
  blocks,
  flowId,
  flowStatus,
  lists,
  readOnly,
  onConfigChange,
  onListsChanged,
}) => {
  if (!block) {
    return (
      <Typography variant='body2' color='text.secondary' sx={{ p: 2 }}>
        Wähle einen Block im Canvas aus.
      </Typography>
    );
  }
  const def = BLOCK_TYPES[block.type];
  if (!def) return null;
  const Icon = def.Icon;
  const handleConfigChange = partial => onConfigChange(block.blockId, partial);

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 1.5,
            bgcolor: alpha(def.color, 0.15),
            color: def.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon fontSize='small' />
        </Box>
        <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
          {def.title}
        </Typography>
      </Box>
      {block.type === 'listSignup' && (
        <ListSignupSettings
          block={block}
          lists={lists}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
          onListsChanged={onListsChanged}
        />
      )}
      {block.type === 'specialOccasion' && (
        <SpecialOccasionSettings block={block} readOnly={readOnly} onConfigChange={handleConfigChange} />
      )}
      {block.type === 'wait' && (
        <WaitSettings block={block} readOnly={readOnly} onConfigChange={handleConfigChange} />
      )}
      {block.type === 'issueVoucher' && (
        <IssueVoucherSettings block={block} readOnly={readOnly} onConfigChange={handleConfigChange} />
      )}
      {block.type === 'increaseVoucherValue' && (
        <IncreaseVoucherSettings
          block={block}
          blocks={blocks}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
      {block.type === 'getresponseSync' && (
        <GetResponseSyncSettings
          block={block}
          blocks={blocks}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
      {block.type === 'getresponseTag' && (
        <GetResponseTagSettings block={block} readOnly={readOnly} onConfigChange={handleConfigChange} />
      )}
      {block.type === 'condition' && (
        <ConditionSettings
          block={block}
          blocks={blocks}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
      {block.type === 'conditionalSplit' && (
        <ConditionalSplitSettings
          block={block}
          blocks={blocks}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
      {TRIGGER_SETTINGS_TYPES.includes(block.type) && (
        <TriggerSettings
          block={block}
          flowId={flowId}
          flowStatus={flowStatus}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
      {ACTION_SETTINGS_TYPES.includes(block.type) && (
        <ActionBlockSettings
          block={block}
          lists={lists}
          readOnly={readOnly}
          onConfigChange={handleConfigChange}
        />
      )}
    </Box>
  );
};

export default BlockPropertiesPanel;
